import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import {
  fetchBoardDetails,
  fetchBoardIdeas,
  fetchBoardLimits,
} from "store/currentBoardSlice";

function BoardDetailsLayout() {
  const dispatch = useDispatch();
  const { boardId } = useParams();
  useEffect(() => {
    boardId && dispatch(fetchBoardDetails(boardId));
    dispatch(fetchBoardLimits(boardId));
    dispatch(fetchBoardIdeas(boardId));
  }, [dispatch, boardId]);

  return <Outlet />;
}

export default BoardDetailsLayout;
